/* eslint-disable jsx-a11y/label-has-associated-control , react/no-unescaped-entities */
import React,{ useState,forwardRef, useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { useFormContext,Controller } from 'react-hook-form';
import UserMultiSelect from './components/UserMultiSelect';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    wrp:{
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title:{
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1.25rem',
        margin: '0 0 2rem 0', 
        textAlign: 'left',
        color:"#333",
        
      },
    fieldsetBox:{
        marginBottom:theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
        '& label':{
            fontFamily: 'VodafoneRg-bold', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            display:'block',
        },
        '& input[type="text"],input[type="date"],select':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '2.5rem',
            border: '1px solid #333',
            // padding: '0.5rem',
            boxSizing: 'border-box',
        },
        '& input[type=date]:before':{content:'none'},
        '& textarea':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '8.5rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            resize:'none'
        },
        
        
    },
    basicSearchchallengeOwner:{
        fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '3rem',
            // border: '1px solid #333',
            // padding: '0.5rem',
            boxSizing: 'border-box',
    },
    error:{
        color:"red",
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
    },
    labelname:{
        fontFamily: 'VodafoneRg-bold', 
        margin: '0 0 0.5rem 0', 
        fontSize: '1.125rem',
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    
    wrp2cols:{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1rem'
    },
  }));
  
  export const ChallengeOwner = (props) => {
  const {
    listCommunitesChallenge: listCommunites = [],
    getSearchUserFn,
    searchUserSuggestions,
    searchUserSuggestionsIsLoading,
    onUserChange,
    userEmail,
    isAdmin,
  } = props || {}

  const classes = useStyles()
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const [optionList, setOptionList] = useState([])
  const [challengeOwnerMustApprove, setChallengeOwnerMustApprove] = useState(true)

  const handleChange = (event) => {
    setChallengeOwnerMustApprove(event.target.checked)
  }

//   const handleValueChange = useCallback((val) => {
//     console.log('selected value change', val)
//   }, [])

  useEffect(() => {
    const challengeOwnerOption = listCommunites.map(group => ({
      value: group.id,
      label: group.name,
    }))

    const filterChallengeOwnerOption = challengeOwnerOption.sort((a, b) =>
      a?.label?.localeCompare(b?.label)
    )

    setOptionList(filterChallengeOwnerOption)
  }, [listCommunites])

  return (
    <div className={classes.wrp}>
      <h3 className={classes.labelname}>Communities</h3>

      <fieldset className={classes.fieldsetBox}>
        <label
          htmlFor="communities"
          title="*Only people in these communities can submit ideas, like, rate and comment."
        >
          Select Communities who can submit ideas*
        </label>

        <Controller
          name="communities"
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              options={optionList}
              isMulti
              placeholder="Select..."
              id="communities"
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  borderColor: '#333',
                }),
              }}
            />
          )}
        />

        {errors?.communities?.message && (
          <p className={classes.error}>{errors?.communities?.message}</p>
        )}
      </fieldset>

      <fieldset className={classes.fieldsetBox}>
        <label htmlFor="search">Challenge Co-Organizer </label>
        <p><b>Note:</b> Please ensure the co-organizer is part of the community  </p>
        <Controller
          name="search"
          control={control}
          defaultValue={[]}
          render={({ field }) => {
            
            const handleSearchUserOnChange = (users) => {
            let updatedUsers = users || []
  
            //  only block adding current user
            if (isAdmin && userEmail) {
              updatedUsers = updatedUsers.filter(
                user => user.value !== userEmail
              )
            }
          
            field.onChange(updatedUsers) 
            onUserChange?.(updatedUsers)
          }
                // const handleSearchUserOnChange = (users) => {
                //     field.onChange(users || [])       
                //     onUserChange?.(users || [])        
                // }


            return (
              <UserMultiSelect
                value={field.value || []}
                onChange={handleSearchUserOnChange}
                fetchUserSuggestions={getSearchUserFn}
                searchUserSuggestions={searchUserSuggestions}
                isLoading={searchUserSuggestionsIsLoading}

                userEmail={userEmail}   
                isAdmin={isAdmin}

              />
            )
          }}
        />

        {errors?.search?.message && (
          <p className={classes.error}>{errors?.search?.message}</p>
        )}
      </fieldset>
    </div>
  )
}


const MultiSelectCheckbox = forwardRef(
    (props,ref) => {
        const { optionData,idname,onChange } = props || {}
    
        const filterColors = (inputValue) => {
            return optionData.filter((i) =>
                i.label.toLowerCase().includes(inputValue.toLowerCase())
            );
        };
    
        const promiseOptions = (inputValue) =>
            new Promise((resolve) => {
                setTimeout(() => {
                    resolve(filterColors(inputValue));
                }, 1000);
            });
    
        return (
            <AsyncSelect
                placeholder=' Select...'
                isMulti
                defaultOptions
                loadOptions={promiseOptions}
                id={idname}
                onChange={onChange}
                ref={ref}
            />
        )
    } 
)


MultiSelectCheckbox.displayName = 'MultiSelectCheckbox';


